var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default filter-panel"},[_vm._m(0),_c('div',{staticClass:"filter-panel__right"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-panel__left"},[_c('i',{staticClass:"fas fa-filter"})])
}]

export { render, staticRenderFns }